import { c as _c } from "react/compiler-runtime";
/**
 * @deprecated This hook is deprecated. Use useAuth() instead.
 * This file is kept for backward compatibility but should not be used in new code.
 */
import app from "../../../global-account/app.js";
import debug from "../../../shared/utils/debug.js";
import { useCallback } from "react";
import { useSearchParam } from "./useSearchParamsSSR.js";
/**
 * @deprecated Use useAuth() instead
 */
export function useTWAuth() {
  const $ = _c(4);
  const referralCode = useSearchParam("referralCode");
  let t0;
  if ($[0] !== referralCode) {
    t0 = async (wallet, partnerId) => {
      if (!wallet || !wallet?.getAuthToken?.()) {
        throw new Error("Wallet not found");
      }
      const authToken = wallet.getAuthToken();
      debug("@@useTWSignIn:authToken", authToken);
      debug("@@useTWSignIn:referralCode", referralCode);
      const response = await app.authenticate({
        strategy: "thirdweb-jwt",
        accessToken: authToken,
        referralCode,
        partnerId
      });
      debug("@@useTWSignIn:response", response);
      return response;
    };
    $[0] = referralCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const authenticate = t0;
  let t1;
  if ($[2] !== authenticate) {
    t1 = {
      authenticate
    };
    $[2] = authenticate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}